import { TypographyProps, Typography } from '@mui/material';
import { FunctionComponent } from 'react';

export const StaticPageSectionHeader: FunctionComponent<TypographyProps> = ({
  children,
  sx,
}) => (
  <Typography
    sx={{
      fontSize: '22px',
      lineHeight: '140%',
      letterSpacing: '3.85px',
      textTransform: 'uppercase',
      my: 6,
      ...sx,
    }}
    gutterBottom
  >
    {children}
  </Typography>
);

export const GoPremiumHeader: FunctionComponent<TypographyProps> = ({
  children,
  sx,
}) => (
  <Typography
    variant={'h2'}
    sx={{
      fontSize: 28,
      lineHeight: '32px',
      letterSpacing: '0.22px',
      mt: 3,
      ...sx,
    }}
    gutterBottom
  >
    {children}
  </Typography>
);

export const GoPremiumBody: FunctionComponent<TypographyProps> = ({
  children,
  sx,
}) => (
  <Typography
    variant={'h2'}
    sx={{
      lineHeight: '20px',
      letterSpacing: '0.8px',
      fontWeight: 400,
      mb: 3,
      ...sx,
    }}
  >
    {children}
  </Typography>
);
